import { render, staticRenderFns } from "./BusinessTypeSelector.vue?vue&type=template&id=b634cb86&"
import script from "./BusinessTypeSelector.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports